const colors = {
  white: "white",
  black: "#141414",
  dark: "#1a1a1a",
  almostWhite: "#f7f7f7"
};

export default colors;
